"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function TagsTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'tags',
        theme: 'twotone',
        nameWithTheme: 'tags-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5c4.4-16.6 17.4-29.5 33.9-33.9 16.6-4.4 34.2.3 46.4 12.4 12.1 12.1 16.9 29.8 12.4 46.4-4.4 16.6-17.4 29.5-33.9 33.9-16.6 4.4-34.2-.3-46.4-12.4-12.1-12.2-16.8-29.9-12.4-46.4z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1c-3.1-3.1-3.1-8.2 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8c-3.1 3.1-3.1 8.2 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M889.7 539.8l-39.6-39.5c-3.1-3.1-8.2-3.1-11.3 0l-362 361.3-237.6-237c-3.1-3.1-8.2-3.1-11.3 0l-39.6 39.5c-3.1 3.1-3.1 8.2 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3c16.6-4.4 29.5-17.4 33.9-33.9 4.4-16.6-.3-34.2-12.4-46.4-12.1-12.1-29.8-16.9-46.4-12.4-16.6 4.4-29.5 17.4-33.9 33.9-4.4 16.6.3 34.2 12.4 46.4 12.2 12.1 29.9 16.8 46.4 12.4z',
                    fill: primaryColor
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M137.7 444.8c-3.1 3.1-3.1 8.2 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'tags-twotone';
var TagsTwoTone = temp;
exports.default = TagsTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/twotone/TagsTwoTone.js
// module id = 1151
// module chunks = 0 1